import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createNewProject,

} from "../../../common/services/uiService";

export const createProjectThunk = createAsyncThunk(
  "projects/createProject",
  async ({ endpoint, payload }, thunkAPI) => {
    try {
      const data = await createNewProject(endpoint, payload);
      // console.log("createProject 2")

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);


